/** Conversation Finder products + referral payout accounts — English (structure pinned to fr). */
import type { CatchProductsKeys } from './fr';

const catchProductsEn: CatchProductsKeys = {
  products: {
    title: 'Your products',
    hint: 'Each keyword belongs to one product, so a draft discloses the right product in its disclosure line.',
    switcherLabel: 'Selected product',
    defaultBadge: 'Default',
    untitled: 'Untitled product',
    newProduct: 'New product',
    newName: 'New product name',
    newUrl: 'New product URL',
    newLang: 'New product disclosure language',
    create: 'Add product',
    created: 'Product added.',
    nameRequired: 'The product name is required.',
    save: 'Save product',
    saved: 'Product saved.',
    makeDefault: 'Make default',
    madeDefault: 'Default product updated.',
    remove: 'Delete product',
    deleteConfirm: 'Delete “{{name}}”? Its keywords are deleted; conversations already found are kept.',
    deleted: 'Product deleted.',
    empty: 'Add your first product to track its keywords.',
    overLimitReadOnly:
      'This product is above your plan limit, so it is read-only. Delete it or upgrade your plan.',
    keywordsFor: 'Keywords for “{{name}}”',
    keywordConflict: '“{{keyword}}” is already tracked for the product “{{product}}”.',
    filterLabel: 'Product',
    filterAll: 'All products',
    discloseProduct: 'Product to mention',
    cardProduct: 'Product: {{name}}',
  },
  payouts: {
    title: 'Payout accounts',
    hint: 'Each account is one of your own Stripe platforms. Each program picks the account that pays its partners.',
    defaultBadge: 'Default',
    empty: 'No payout account yet. Add your Stripe key to pay partners automatically.',
    newAccount: 'New account',
    name: 'Account name',
    secretKey: 'Stripe secret key (sk_ or rk_)',
    secretKeyHint: 'Verified with Stripe, then encrypted. It is never shown again.',
    replaceKey: 'New secret key (leave empty to keep the current one)',
    create: 'Add account',
    created: 'Account added.',
    save: 'Save',
    saved: 'Account saved.',
    edit: 'Edit',
    cancel: 'Cancel',
    clearKey: 'Remove key',
    keyCleared: 'Key removed.',
    makeDefault: 'Make default',
    madeDefault: 'Default account updated.',
    remove: 'Delete',
    deleteConfirm: 'Delete the account “{{name}}”? Programs using it will switch to the default account.',
    deleted: 'Account deleted.',
    configured: 'Stripe {{account}} ({{mode}}) · key {{hint}}',
    notConfigured: 'Stripe not configured (CSV export only)',
    live: 'live',
    test: 'test',
    programs: '{{count}} program(s)',
    overLimitReadOnly:
      'This account is above your plan limit: it is read-only but keeps paying the programs that use it.',
    programAccount: 'Payout account',
    programAccountDefault: 'Default account',
    programAccountHint: 'The Stripe platform that pays this program’s partners.',
    usedAccount: 'Payouts through “{{name}}”',
  },
};

export default catchProductsEn;
